module.exports = __webpack_public_path__ + "static/media/photo-3.353b2d41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/crescent-extension/photo-3.jpg
// module id = 158
// module chunks = 0